import ServiceDetailLayout from '../../components/ServiceDetailLayout';

export default function GraphicDesignPage() {
  return <ServiceDetailLayout slug="graphic-design" />;
}
